import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { getStartDateForSchoolYear } from '../../../../../../helpers/calendar/calendar';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

export function ExtendedTournamentScheduleReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  const requestInitial = { dateFrom: getStartDateForSchoolYear(now), dateTo: now };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EXTENDED_TOURNAMENT_SCHEDULE)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm unionTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>
              View the complete tournament schedule, including bookings, remaining places, organiser details and linked
              web addresses.
            </ReportDescription>
            <ReportSection
              number={1}
              title="Reporting period"
              hint="Choose the date range covered by the tournament schedule."
              required
            >
              <ReportDateRange
                dateFrom={values.dateFrom}
                dateTo={values.dateTo}
                onChangeFrom={date => {
                  setFieldValue('dateFrom', date);
                  if (values.dateTo < date) setFieldValue('dateTo', date);
                }}
                onChangeTo={date => setFieldValue('dateTo', date)}
              />
            </ReportSection>
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
